import styled from '@emotion/styled';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import cloudLeft from 'assets/images/magic/TileCloudRight.svg';
import cloudRight from 'assets/images/magic/TileCloudLeft.svg';

export const TileContainer = styled.div`
  position: relative;

  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: left 10px top 12px / auto 70% no-repeat url(${cloudLeft}),
    right 10px top 12px / auto 70% no-repeat url(${cloudRight}),
    ${props => props.theme.COLORSV3.BAY_100};

  border-radius: 8px;
  padding: 12px;

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    background: left 12px center / auto 90% no-repeat url(${cloudLeft}),
      right 12px center / auto 90% no-repeat url(${cloudRight}),
      ${props => props.theme.COLORSV3.BAY_100};
  }
`;

export const Image = styled.picture`
  margin: 30px 0;
  img {
    display: block;
  }
`;

export const Title = styled.span`
  font-family: ${props => props.theme.FONTS.FONT_FAMILY_NEW_SPIRIT};
  font-size: 28px;
  font-weight: ${props => props.theme.FONTS.WEIGHT.MEDIUM};
  line-height: 1.1;
  text-align: center;
  color: ${props => props.theme.COLORSV3.WHITE_100};

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    font-size: ${props => props.theme.FONTS.FONT_SIZE_LARGER};
  }
`;

export const MagicButton = styled(ButtonV3)`
  display: none;
  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    display: inherit;
  }
`;

export const MagicLink = styled(LinkV2)`
  display: block;
  text-align: center;
  line-height: 24px;

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    display: none;
  }
`;

export const LeftCloud = styled.img`
  display: block;
  position: absolute;
  left: 0;
`;

export const RightCloud = styled.img`
  display: block;
  position: absolute;
  right: 0;
`;
